import { textAnimations } from './utils/text-animations';
import { initMediasEvents } from './utils/medias';

export default function (root = document) {
    textAnimations(root);

    if (root === document) {
        initMediasEvents();
    }
}
